import styled from 'styled-components'

export const Wrapper = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  min-width: 320px;
  overflow: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`

export const Main = styled.main`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
`

export const Header = styled.header`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Footer = styled.footer`
  flex-shrink: 0;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.8rem;

  a {
    cursor: pointer;
    color: ${p => p.theme.colors.info};
  }

  span {
    opacity: 0.6;
  }
`
